import { Routes } from '@angular/router';
import { TeamComponent } from './team/team.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { QuestionTypeComponent } from './question-type/question-type.component';
import { SvStatusComponent } from './sv-status/sv-status.component';

import { QUESTION_TYPE_ROUTES } from './question-type/question-type.routes';
import { PERMISSIONS_ROUTES } from './permissions/permissions.routes';
import { TEAM_ROUTES } from './team/team.routes';
import { SV_STATUS_ROUTES } from './sv-status/sv-status.routes';


export const ORG_ROUTES: Routes = [    
    { path: 'equipos', component: TeamComponent, children: TEAM_ROUTES },
    { path: 'permisos', component: PermissionsComponent,children: PERMISSIONS_ROUTES },
    { path: 'tipo-preg', component: QuestionTypeComponent, children: QUESTION_TYPE_ROUTES },
    { path: 'estados', component: SvStatusComponent, children: SV_STATUS_ROUTES },
    { path: '**', pathMatch: 'full', redirectTo: 'equipos'}
];